import React from 'react';
import { TravelExpenseResults } from 'api/services/TravelExpenses';
import {
  Box,
  Flex,
  Heading,
  Tooltip,
  Spinner as ChakraSpinner,
} from '@chakra-ui/react';
import { Alert } from 'components/Alert/Alert';
import { Spinner } from 'components/Spinner';
import moment from 'moment';
import { IconTrash } from 'components/Icons';

type DailyAllowanceTableOverviewProps = {
  isError: boolean;
  isFetching: boolean;
  data: TravelExpenseResults[];
  noDataText: string;
  handleDeleteCostLine: (lineId: string | undefined) => void;
  isDeletingCostLine: boolean;
};
export const DailyAllowanceTableOverview = ({
  isError,
  isFetching,
  data,
  handleDeleteCostLine,
  isDeletingCostLine,
}: DailyAllowanceTableOverviewProps): JSX.Element | null => {
  if (isError) {
    return (
      <Box as="div" mt={10}>
        <Alert
          errorText="Ekki tókst að sækja dapeningaliði fyrir tiltekna beiðni"
          status="error"
        />
      </Box>
    );
  }

  const reversedDataOrder = [...data].reverse();

  return data.length > 0 ? (
    <Box as="div" mt={10}>
      <Heading size={'md'}>Staðfesting vegna dagpeninga</Heading>
      {isFetching ? (
        <Spinner delay={300} isFixed={false} />
      ) : (
        reversedDataOrder.map((val, index) => {
          const { costDateFrom, costDateTo, id } = val;
          return (
            <Box key={index} display="flex" mt={5}>
              <Box fontWeight={600} color="gray.400" mr={10}>
                Tímabil dagpeninga:
              </Box>
              <Flex dir="row">
                {`${moment(costDateFrom).format('DD.MM.YYYY')} -
              ${moment(costDateTo).format('DD.MM.YYYY')}`}
                <Tooltip label="Afturkalla staðfestingu">
                  <Box as="div" ml={10}>
                    {isDeletingCostLine ? (
                      <ChakraSpinner size="md" />
                    ) : (
                      <IconTrash
                        style={{ cursor: 'pointer' }}
                        width={20}
                        onClick={(): void => handleDeleteCostLine?.(id)}
                      />
                    )}
                  </Box>
                </Tooltip>
              </Flex>
            </Box>
          );
        })
      )}
    </Box>
  ) : null;
};
